import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function Detail({icon, label, value}) {
  return <div className="profile-detail"><span><SafeIcon icon={icon} /></span><div><small>{label}</small><strong>{value}</strong></div></div>;
}

function ProfilePage({user, language, setLanguage, onSignOut, t, progress, onboardingProgress}) {
  const formattedDate = new Intl.DateTimeFormat(language === 'es' ? 'es' : 'en', {year: 'numeric', month: 'long', day: 'numeric'}).format(new Date(user.joinedAt));
  const completedVideos = Object.values(progress).filter((item) => item.completedAt).length;
  const userOnboarding = onboardingProgress.filter((item) => item.userId === user.id);
  const completedSteps = userOnboarding.filter((item) => item.status === 'Done').length;

  return <motion.div className="page-content profile-page" initial={{opacity: 0}} animate={{opacity: 1}}>
    <div className="page-title"><span className="eyebrow">{t.profileDetails}</span><h1>{t.profile}</h1></div>
    <section className="profile-card">
      <div className="profile-summary"><span className="avatar avatar-large">{user.avatar}</span><div><h2>{user.name}</h2><span className="role-badge">{t[user.role]}</span></div></div>
      <div className="details-grid">
        <Detail icon={FiIcons.FiMail} label={t.email} value={user.email} />
        <Detail icon={FiIcons.FiMapPin} label={t.country} value={user.country} />
        <Detail icon={FiIcons.FiCalendar} label={t.memberSince} value={formattedDate} />
        <div className="language-field"><label htmlFor="preferred-language">{t.preferredLanguage}</label><select id="preferred-language" value={language} onChange={(event) => setLanguage(event.target.value)}><option value="en">English</option><option value="es">Español</option></select></div>
      </div>
      <section className="completion-summary"><h2>{language === 'es' ? 'Mis avances' : 'My completions'}</h2><div><article><SafeIcon icon={FiIcons.FiPlayCircle} /><strong>{completedVideos}</strong><span>{language === 'es' ? 'videos completados' : 'videos completed'}</span></article><article><SafeIcon icon={FiIcons.FiCheckSquare} /><strong>{completedSteps}/9</strong><span>{language === 'es' ? 'pasos de incorporación' : 'onboarding steps'}</span></article></div></section>
      <button type="button" className="signout-button" onClick={onSignOut}><SafeIcon icon={FiIcons.FiLogOut} />{t.signOut}</button>
    </section>
  </motion.div>;
}

export default ProfilePage;